import { render, staticRenderFns } from "./SystemConfigSchoolDialog.vue?vue&type=template&id=2eb6d590&scoped=true"
import script from "./SystemConfigSchoolDialog.vue?vue&type=script&lang=js"
export * from "./SystemConfigSchoolDialog.vue?vue&type=script&lang=js"
import style0 from "./SystemConfigSchoolDialog.vue?vue&type=style&index=0&id=2eb6d590&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb6d590",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eb6d590')) {
      api.createRecord('2eb6d590', component.options)
    } else {
      api.reload('2eb6d590', component.options)
    }
    module.hot.accept("./SystemConfigSchoolDialog.vue?vue&type=template&id=2eb6d590&scoped=true", function () {
      api.rerender('2eb6d590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/SystemConfigSchoolDialog.vue"
export default component.exports